import { format } from 'date-fns';

const DEFAULT_DATE_FORMAT = 'MMMM d, yyyy';

export const formatTimestamp = (
  timestamp: string | Date,
  formatRule: string = DEFAULT_DATE_FORMAT
): string => {
  const date = new Date(timestamp);
  return format(date, formatRule);
};
